import {get, post} from "../../DAL/data-provider";
import {getJSONFromHtml} from "../../domain/common";


export const getCountriesAndStates = async () => {
    return get('/api/Dealers/get-countries-and-states');
};

export const postGetDealers = async (countryId:string, stateId:string) => {
    let GetDealersRequest;
    if (countryId && countryId !== '0' && countryId !== ''){
        GetDealersRequest = {
            countryCode:countryId,
            stateCode: stateId !== '0' && stateId !== '' ? stateId : ''
        }
    }
    return post('/api/Dealers/get-dealers', GetDealersRequest);
};

export const getAllDealers = async (showAll:number) => {
    return get(`/api/Dealers/get-all-dealers?showAll=${showAll}`);
};

export const getProductListData = () => {
    const productList = getJSONFromHtml(document.getElementById('product-types-list'));
    if (!productList) return [];
    else {
        return productList;
    }
}

